import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../utilities/LogErrors'
//import { useLanguage } from './../../../../utilities/LanguageContext'

//Funciones personalizadas
import { ValidateSession } from './../../../../utilities/BL/Sessions'
import { SetDefaultWebTheme } from './../../../../utilities/BL/Settings'
//import { GetCourses as BLGetCourses } from './../../../../utilities/BL/Student/Courses'
import { GetAndSetCenterAndRole, ResetCourseToShow, SaveCenterAndRoleToShow } from './../../../../utilities/BL/Navigation' //SaveCenterToShow, SaveRoleToShow
import { MarkFirstTimeEntry } from './../../../../utilities/BL/Users'
//import { GetResults } from './../../../../utilities/BL/Student/Results'

//Componentes comunes generales
//import { Header } from './../../../Header/Header'
//import { Section } from './../../Section'
import { Loading } from './../../../Common/Loading'

//Componentes del proyecto
import { Modal } from './../Modal'
//import { Ztudiant } from './../Ztudiant'
import { Ztudiant } from './../V2/Ztudiant'
//import { Applicant } from './../../Instructor/Instructor'
import { Applicant } from './../../Instructor/V2/Instructor'
import { Leader } from './../../Leader/Leader'
// //import { Subdashboard } from './../Subdashboard'
// import { Tile } from './../Tile'
// import { GoToTop } from './../../../Common/GoToTop'
// import { Button } from './../../../Common/Button'
// import { Result } from './../Result'


//Ver cómo mostrar los mensajes de error. Conforme salga un error.


const Dashboard = () => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)
    const [session, setSession] = useState({})
    
    const [theme, setTheme] = useState(null)
    const [centerSelected, setCenterSelected] = useState(null)
    const [roleSelected, setRoleSelected] = useState(null)
    

    const LoadPage = async (sessionInfo) => {
        try {
            //Establecer el tema a la web
            const response = await SetDefaultWebTheme()

            if (response.success) {
                setTheme(response.data)
            }
            

            const currentSessionInfo = await ResetCourseToShow(sessionInfo)
            
            if (currentSessionInfo.success) {
                const response = await GetAndSetCenterAndRole(currentSessionInfo.data)
                
                if (response.success) {
                    // Guardar en el estado, el centro y perfil seleccionados (o nulos)
                    setCenterSelected(parseInt(response.data.center))
                    setRoleSelected(parseInt(response.data.role))
    
                    // Guardar en sessionStorage el centro y perfil seleccionados (o nulos)
                    let responseCenterAndRole
                    let center = null
                    let role = null

                    if (response.data.center !== null) {
                        if (!isNaN(response.data.center)) {
                            center = parseInt(response.data.center)
                        }
                    }

                    if (response.data.role !== null) {
                        if (!isNaN(response.data.role)) {
                            role = parseInt(response.data.role)
                        }
                    }
                    
                    responseCenterAndRole = await SaveCenterAndRoleToShow(currentSessionInfo.data, center, role)
                    setSession(responseCenterAndRole.data)
                } else {
                    setSession(currentSessionInfo.data)
                }
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log(currentSessionInfo.message) //Mensaje temporal
                setSession(sessionInfo.data)
            }
        } catch (error) {
            await LogErrors('LoadPage - Dashboard', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            //setSession(tmpSession.data)
            
            if (tmpSession.success) {
                if (tmpSession.data.user.userStatus === 2) {
                    await LoadPage(tmpSession.data)
                } else {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar

    /**
     * Marca el primer ingreso al centro con el perfil elegido. Se dispara aquí, en el
     * único punto compartido por los tres roles (Ztudiante/Instructor/Líder) antes de
     * mostrar su dashboard correspondiente. Es una llamada silenciosa: no bloquea el
     * render ni informa al usuario si falla, solo se registra el error.
     */
    useEffect(() => {
        if (!centerSelected || !roleSelected) return

        MarkFirstTimeEntry(centerSelected, roleSelected)
    }, [centerSelected, roleSelected])


    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {/* Mostrar el modal hasta que se elijan perfil y avatar */}
                    {!centerSelected || !roleSelected ? (
                        <Modal session={session} centersData={session.user.centers} setCenterSelected={setCenterSelected} setRoleSelected={setRoleSelected} />
                    ) : (
                        <>
                            {roleSelected === 1 && <Ztudiant session={session} setSession={setSession} theme={theme} setTheme={setTheme} centerSelected={centerSelected} roleSelected={roleSelected} />}
                            {roleSelected === 2 && <Applicant theme={theme} setTheme={setTheme} />}
                            {roleSelected === 3 && <Leader theme={theme} setTheme={setTheme} />}
                        </>
                    )}
                </>
            )}
        </>
    )
}

export { Dashboard };